<template>
  <div>
    <div class="popup-wrapper" @click.self="close">
      <div class="popup-container xl">
        <div class="button close">
          <span role="button" class="btn" @click="close">
            <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
          </span>
        </div>
        <div class="popup">
          <div class="popup-title">
            <span class="hdg02">ノートの選択</span>
          </div>
          <div class="popup-content">
            <div class="popup-content-01">
              <div class="popup-content-hdg">
                <p class="hdg03 line">新規ノートを作成して保存する</p>
                <div class="popup-content-hdg-sup">
                  <span class="small">使用ノート数</span>
                  <span class="large"><span :class="[noteNum.createNote >= noteNum.maxNote && 'max']">{{noteNum.formatCreateNote}}</span> / {{noteNum.formatMaxNote}}</span>
                  <span class="small">最大ノート数</span>
                </div>
              </div>
              <form @submit.prevent action="" id="note_select_new">
                <div class="popup-content-body">

                  <div class="popup-content-body-item popup-content-body-item-01">
                    <p class="hdg04">ノートのタイトル</p>
                    <div class="formparts text">
                      <input @keydown.enter.prevent type="text" placeholder="タイトルを入力" v-model="newNote.title">
                      <p v-if="validate.title" class="error-message">{{validate.title}}</p>
                    </div>
                  </div>
                  <div 
                    v-show="state.isShareAreaShown"
                    class="popup-content-body-item popup-content-body-item-02">
                    <p class="hdg04">共有指定</p>
                    <div class="formparts radio">
                      <input type="radio" id="note_select_share_1" 
                        :value="1" 
                        v-model.number="newNote.share"
                        @change="share.onShareTypeChanged">
                      <label for="note_select_share_1">プライベート</label>
                    </div>
                    <div class="formparts radio">
                      <input type="radio" id="note_select_share_2" 
                        :value="2" 
                        v-model.number="newNote.share"
                        @change="share.onShareTypeChanged">
                      <label for="note_select_share_2">共有</label>
                    </div>
                    <p class="error-message" 
                      v-if="newNote.share === 2 && !share.isUsersToShareSelected"
                      >アカウントを指定してください。</p>
                    <div class="formparts-hidden"
                      v-show="newNote.share === 2">
                      <div class="formparts radio">
                        <input type="radio" id="note_select_share_classification_21" 
                          :value="21"
                          v-model.number="newNote.share_classification"
                          @click="share.onShareClassificationClicked(21, true)"
                          :disabled="newNote.share !== 2">
                        <label for="note_select_share_classification_21">閲覧権限を付与する</label>
                        <a class="txt-blue" role="button"
                          v-if="newNote.share_classification === 21 && share.isUsersToShareSelected"
                          @click="share.onShareClassificationClicked(21, false)">閲覧・編集</a>
                      </div>
                      <div class="formparts radio">
                        <input type="radio" id="note_select_share_classification_22" 
                          :value="22"
                          v-model.number="newNote.share_classification"
                          @click="share.onShareClassificationClicked(22, true)"
                          :disabled="newNote.share !== 2">
                        <label for="note_select_share_classification_22">編集権限を付与する</label>
                        <a class="txt-blue" role="button"
                          v-if="newNote.share_classification === 22 && share.isUsersToShareSelected"
                          @click="share.onShareClassificationClicked(22, false)">閲覧・編集</a>
                      </div>
                    </div>
                  </div>

                  <div class="popup-content-body-item popup-content-body-item-03">
                    <div class="note-editor-accordion">
                      <h4 class="hdg04 note-editor-accordion-head"
                        @click="state.isOpenAccordionNewNote = !state.isOpenAccordionNewNote">
                        タグ・見出し・コメントを追加
                        <FontawesomeIcon icon="angle-down" class="icn" v-if="!state.isOpenAccordionNewNote" />
                        <FontawesomeIcon icon="angle-up" class="icn" v-else />
                      </h4>
                      <div class="note-editor-accordion-body"
                        v-show="state.isOpenAccordionNewNote">
                        <p class="hdg04">タグ</p>
                        <div class="column al-center">
                          <div class="column-item col-6">
                            <div class="formparts function">
                              <input @keydown.enter.prevent="newNote.clickAddTag" type="text" v-model="newNote.tagText">
                              <div @click="newNote.clickAddTag" class="button" role="button"><span class="icn register">登録</span></div>
                            </div>
                          </div>
                          <div v-if="newNote.displayPastTags.length > 0" class="column-item col-6 space-left">
                            <span role="button" class="txt-blue mt12"
                              @click="state.isOpenHistoryTags = !state.isOpenHistoryTags"
                              :class="{'is-open' : state.isOpenHistoryTags}"
                            >
                              登録済のタグから追加
                              <FontawesomeIcon icon="angle-down" class="icn down" />
                              <FontawesomeIcon icon="angle-up" class="icn up" />
                            </span>
                          </div>
                        </div>
                        <div class="tags-history mt8"
                          v-if="state.isOpenHistoryTags && newNote.displayPastTags.length > 0"
                        >
                          <div  
                            v-for="tag in newNote.displayPastTags"
                            :key="'pastTags_' + tag.id"
                            @click="newNote.clickPastTag(tag.name)"
                            class="tag bottom"
                          >
                            <div role="button" class="tag-wrap">
                              <span class="tag-text">{{tag.name}}</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="newNote.tags.length > 0" class="mt8">
                          <div
                            v-for="tag in newNote.tags"
                            :key="'Tags_' + tag"
                            @click="newNote.clickTag(tag)"
                            class="tag"
                          >
                            <div role="button" class="tag-wrap">
                              <span class="tag-text">{{tag}}</span>
                              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                            </div>
                          </div>
                        </div>
                        <p class="hdg04">見出し</p>
                        <div class="formparts text">
                          <input @keydown.enter.prevent type="text" placeholder="見出しを入力" v-model="newNote.heading">
                        </div>
                        <p class="hdg04">コメント</p>
                        <div class="formparts textarea">
                          <textarea rows="5" placeholder="コメントを入力" v-model="newNote.comment"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="popup-content-body-item popup-content-body-item-06">
                    <div class="button" :class="[!newNote.isInputDataValid && 'is-inactive']">
                      <button class="btn" type="submit" name="loguot" 
                        :class="ga.noteSaveClass" 
                        :disabled="!newNote.isInputDataValid"
                        @click="newNote.clickSubmit">作成して保存</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="popup-content-02">
              <div class="popup-content-hdg">
                <p class="hdg03 line">保存先のノートを選ぶ</p>
              </div>
              <form @submit.prevent action="" id="note_select_save">
                <div class="popup-content-body">
                  <template v-if="!state.isNoteListLoaded">
                    <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt20 mb20 icn fa-spin" />
                  </template>
                  <template v-else>
                    <p v-if="savedNote.lists.length == 0">選択できるノートがありません。</p>
                    <template v-else>
                      <div class="formparts function suggest">
                        <input
                          @keydown.enter.prevent="savedNote.clickSearchNote"
                          type="text" 
                          placeholder="ノートのタイトル" 
                          v-model="savedNote.searchKeyword"
                          :class="[savedNote.selected && 'selected']"
                        >
                        <div @click="savedNote.clickSearchNote" class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
                        <ul v-if="savedNote.lists.length > 0" class="suggest-list">
                          <li
                          v-for="list in savedNote.lists"
                          :key="'saved_' + list.id"
                          @click="savedNote.clickList(list)"
                          role="option"
                          ><label>{{list.title}}<input type="radio" name="rd_group_02"></label>
                          </li>
                        </ul>
                      </div>
                      <div class="note-editor-accordion">
                        <h4 class="hdg04 note-editor-accordion-head"
                          @click="state.isOpenAccordionSelectNote = !state.isOpenAccordionSelectNote">
                          見出し・コメントを追加
                          <FontawesomeIcon icon="angle-down" class="icn" v-if="!state.isOpenAccordionSelectNote" />
                          <FontawesomeIcon icon="angle-up" class="icn" v-else />
                        </h4>
                        <div class="note-editor-accordion-body"
                          v-show="state.isOpenAccordionSelectNote">
                          <p class="hdg04">見出し</p>
                          <div class="formparts text">
                            <input @keydown.enter.prevent type="text" placeholder="見出しを入力" v-model="savedNote.heading">
                          </div>
                          <p class="hdg04">コメント</p>
                          <div class="formparts textarea">
                            <textarea rows="5" placeholder="コメントを入力" v-model="savedNote.comment"></textarea>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <div class="button mt32" :class="[!savedNote.selected && 'is-inactive']">
                    <button class="btn" :class="ga.noteSaveClass" type="submit" name="loguot" @click="savedNote.clickSubmit">保存</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>
    </div>
    <!-- 閲覧/編集権限付与設定ウィンドウ -->
    <transition name="popup">
      <PCNoteUserPermissionsEdit
        v-if="state.visibleNoteUserPermissionsEdit"
        @close="share.hideNoteUserPermissionsEdit"
      />
    </transition>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import PCNoteUserPermissionsEdit from '@/components/pc/popup/PCNoteUserPermissionsEdit.vue'

import { SelectNote } from '@/logic/common/SelectNote'

/**
 * @param  {string} type, knowledge:ナレッジ, qa:QA
 * @param  {string} pageId, ナレッジ・QAのID
 * @param  {string} title, ナレッジ・QAのタイトル
 * 
 */
export default defineComponent({
  props: {
    type: {
      type: String,
      default: ''
    },
    pageId: {
      type: Number,
      default: null
    },
    note_row_id: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    currentNoteId: {
      type: Number,
      default: null
    }
  },
  components: {
    PCNoteUserPermissionsEdit
  },
  setup (props, context) {
    return {...SelectNote(props, context)}
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 0!important;
  &-01 {
    padding: 40px;
    background-color: #F9F8F6;
    .max {
      color: $color-highlight;
    }
  }
  &-02 {
    padding: 40px;
    // padding: 40px 40px 200px 40px;
    .suggest-list {
      max-height: 169px;
    }
    .selected {
      font-weight: bold;
    }
  }
  &-hdg {
    position: relative;
    &-sup {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate3d(0,-50%,0);
      .small {
        vertical-align: middle;
        color: $color-sup;
        font-size: 1.2rem;
      }
      .large {
        margin: 0 10px;
        vertical-align: middle;
        font-size: 2.4rem;
        font-weight: bold;
      }
    }
  }
  &-body {
    background-color: #fff;
    .hdg04 {
      margin-bottom: 20px;
    }
    &-item {
      padding: 30px 40px;
      border-bottom: 1px solid $color-line;
      &:last-child {
        border-bottom: 0;
      }
      &-02 {
        .error-message {
          margin: 8px 0 0;
          padding-left: 30px;
        }
        .formparts-hidden {
          margin-top: 16px;
          padding-left: 30px;
          .formparts {
            display: flex;
            align-items: center;
            a[role="button"] {
              margin-left: 8px;
            }
          }
        }
      }
      &-03 {
        .txt-blue {
          font-size: 1.4rem;
          @include hoverOpacity;
          .up {
            display: none;
          }
          &.is-open {
            .up {
              display: inline;
            }
            .down {
              display: none;
            }
          }
        }
        .tags-history {
          padding-bottom: 20px;
          border-bottom: 1px solid $color-line;
        }
      }
    }
  }
  .btn[type="submit"] {
    margin: 0 auto;
    width: 230px;
  }
}

.note-editor-accordion {
  .note-editor-accordion-head {
    cursor: pointer;
    &.hdg04 {
      margin-bottom: 0;
    }
    .icn {
      margin-left: 16px;
      path {
        fill: #005BAC;
      }
    }
  }
  .note-editor-accordion-body {
    .hdg04 {
      padding-top: 30px;
    }
    .column + .hdg04,
    .formparts + .hdg04 {
      // margin-top: 30px;
      position: relative;
      // &::before {
      //   content: "";
      //   display: block;
      //   width: calc(100% + 80px);
      //   height: 1px;
      //   background-color: $color-line;
      //   position: absolute;
      //   left: -40px;
      //   top: 0;
      // }
    }
  }
}

.popup-content-02 {
  .note-editor-accordion {
    margin-top: 30px;
    padding: 30px 0;
    position: relative;
    // border-top: 1px solid #DDDDDD;
    // border-bottom: 1px solid #DDDDDD;
    &::before,
    &::after {
      content: "";
      display: block;
      width: calc(100% + 80px);
      height: 1px;
      background: #DDDDDD;
      position: absolute;
      left: -40px;
    }
    &::before {
      top: 0;
    }
    &::after {
      bottom: 0;
    }
  }
}

</style>
